/* mfb.js v2 — Myoro Free Box page behaviour. Loaded by every mfb-* section; guards itself so repeat tags no-op.
 * 1) countdown to ONE fixed deadline (no daily reset)   2) every a[data-mfb-claim] gets the hero's checkout URL
 * 3) reveal on scroll (content stays visible if this script never runs)   4) receipt count-up = the page's signature moment
 * 5) mobile sticky CTA: shows after the hero button scrolls away, hides while the final CTA is on screen
 * 6) upgrade popup (08-10): a Claim tap first offers The Ultimate Mystery Gift (section mfb-upsell), then goes to checkout
 */
(function () {
  if (window.__mfb2) return;
  window.__mfb2 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function config() {
    var el = document.getElementById('mfb-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function countdowns(deadlineIso, farHours) {
    var nodes = document.querySelectorAll('[data-mfb-cd]');
    if (!nodes.length) return;
    var end = Date.parse(deadlineIso || '');
    if (isNaN(end)) { nodes.forEach(function (n) { n.hidden = true; }); return; }
    var farMs = (parseFloat(farHours) || 72) * 3600 * 1000;
    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      nodes.forEach(function (n) {
        // Weeks out, a ticking clock reads as staged urgency: show the plain deadline until the last farHours.
        var label = n.querySelector('[data-mfb-cd-label]');
        var far = !!(label && label.getAttribute('data-far')) && left > farMs;
        n.classList.toggle('is-far', far);
        if (label) label.textContent = label.getAttribute(far ? 'data-far' : 'data-near') || label.textContent;
        ['d', 'h', 'm', 's'].forEach(function (k) {
          var el = n.querySelector('[data-mfb-cd-' + k + ']');
          if (el) el.textContent = k === 'd' ? String(v.d) : pad(v[k]);
        });
      });
      if (left > 0) window.setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  // Calendar months, like a plan that bills every N months: same day of the month, clamped to that month's last day.
  function monthsFromNow(m) {
    var now = new Date(), when = new Date(now.getFullYear(), now.getMonth() + m, 1);
    when.setDate(Math.min(now.getDate(), new Date(when.getFullYear(), when.getMonth() + 1, 0).getDate()));
    return when;
  }
  function longDate(d) { return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); }

  // First refill date, computed in the visitor's browser so the page cache can never serve a stale date.
  function refillDates(days, months) {
    var m = parseInt(months, 10), d = parseInt(days, 10), when;
    if (m > 0) when = monthsFromNow(m);
    else if (d > 0) when = new Date(Date.now() + d * 864e5);
    else return;
    var text = longDate(when);
    document.querySelectorAll('[data-mfb-next]').forEach(function (n) { n.textContent = text; });
  }
  // Any other date a section asks for in months, e.g. the upgrade popup's first renewal: <span data-mfb-months="3">.
  function monthDates() {
    document.querySelectorAll('[data-mfb-months]').forEach(function (n) {
      var m = parseInt(n.getAttribute('data-mfb-months'), 10);
      if (m > 0) n.textContent = longDate(monthsFromNow(m));
    });
  }

  function wire(url, code) {
    if (url) document.querySelectorAll('a[data-mfb-claim]').forEach(function (a) { a.setAttribute('href', url); a.removeAttribute('data-mfb-unwired'); });
    if (code) document.querySelectorAll('[data-mfb-code]').forEach(function (n) { n.textContent = code; });
  }

  function countUp(el, to, ms, done) {
    if (reduce) { el.textContent = money(to); if (done) done(); return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = money(Math.round(to * e));
      if (p < 1) requestAnimationFrame(step); else if (done) done();
    }
    requestAnimationFrame(step);
  }

  function receipt(paper) {
    var rows = paper.querySelectorAll('[data-count]');
    var i = 0;
    function next() {
      if (i >= rows.length) { paper.classList.add('is-done'); return; }
      var el = rows[i++];
      countUp(el, parseInt(el.getAttribute('data-count'), 10) || 0, 700, next);
    }
    rows.forEach(function (el) { el.textContent = money(0); });
    next();
  }

  function observe() {
    var hasIO = 'IntersectionObserver' in window;
    var reveals = document.querySelectorAll('.mfb [data-reveal]');
    if (hasIO && !reduce && reveals.length) {
      document.documentElement.classList.add('mfb-js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (r) { io.observe(r); });
    }
    var hero = document.querySelector('.mfb .mfb-hero');
    if (hero) window.setTimeout(function () { hero.classList.add('is-in'); }, 150);

    document.querySelectorAll('.mfb .mfb-paper[data-receipt]').forEach(function (p) {
      if (!hasIO || reduce) { p.classList.add('is-done'); return; }
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { ro.disconnect(); receipt(p); } });
      }, { threshold: 0.45 });
      ro.observe(p);
    });

    var sticky = document.querySelector('.mfb .mfb-sticky');
    var ctas = Array.prototype.filter.call(document.querySelectorAll('.mfb [data-mfb-claim]'), function (a) { return !sticky || !sticky.contains(a); });
    var finalCta = document.querySelector('.mfb .mfb-final');
    if (sticky && ctas.length && hasIO) {
      // Always offer a button on phones: the bar shows whenever no in-page button (hero, receipt) and no final band is on screen.
      var onScreen = [], finalOn = false;
      function paint() { sticky.classList.toggle('is-on', !onScreen.some(Boolean) && !finalOn); }
      var co = new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScreen[ctas.indexOf(e.target)] = e.isIntersecting; });
        paint();
      });
      ctas.forEach(function (a) { co.observe(a); });
      // The final band and the store footer below it keep their own buttons and links clear of the bar.
      if (finalCta) new IntersectionObserver(function (es) { es.forEach(function (e) { finalOn = e.isIntersecting || e.boundingClientRect.top < 0; paint(); }); }).observe(finalCta);
      paint();
    }
  }

  // 6) Upgrade popup. Yes → the Ultimate checkout. No → the Mystery Gift checkout the tapped button points to, remembered for
  // this visit so the next tap goes straight there. All listeners are delegated, so a section the theme editor re-renders
  // keeps working. No <dialog> support → the plain links run as before.
  var UP_KEY = 'mfb-up-choice', upBusy = false, upDown = false;
  function upDialog() {
    var d = document.querySelector('.mfb dialog[data-mfb-upsell]');
    return d && typeof d.showModal === 'function' ? d : null;
  }
  function upChoice(v) {
    try { if (v) window.sessionStorage.setItem(UP_KEY, v); return window.sessionStorage.getItem(UP_KEY); } catch (e) { return null; }
  }
  // A claim link: /discount/CODE?redirect=/cart/add?items[][id]=V&items[][quantity]=1&items[][selling_plan]=P&return_to=/checkout
  function parseClaim(url) {
    var s = url || '';
    try { s = decodeURIComponent(s); } catch (e) { /* keep it raw */ }
    var id = /items\[\]\[id\]=(\d+)/.exec(s), plan = /items\[\]\[selling_plan\]=(\d+)/.exec(s), code = /\/discount\/([^?\/]+)/.exec(s);
    return id ? { id: Number(id[1]), plan: plan ? Number(plan[1]) : 0, code: code ? code[1] : '' } : null;
  }
  // Cart = exactly the chosen box, then checkout with its code. Reasons not to just follow the claim link:
  // /cart/add ADDS, so going back from checkout and choosing again would stack two boxes or two memberships; the theme's cart
  // drawer adds its preselected $10 warranty whenever a visitor lands with a non-empty cart (drop = those handles); and in a
  // theme preview Shopify drops the query string of the link's inner redirect (/cart/add arrives empty, error 400).
  // Anything fails before the add is sent → the plain claim link, which still does it all. After it → checkout only.
  function claimTo(url, ids, drop) {
    var c = parseClaim(url), done = false, added = false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var H = { Accept: 'application/json', 'Content-Type': 'application/json' };
    var checkout = c && c.code ? root + 'discount/' + encodeURIComponent(c.code) + '?redirect=' + root + 'checkout' : root + 'checkout';
    function go(to) { if (!done) { done = true; window.location.assign(to); } }
    if (!c || !window.fetch) return go(url);
    window.setTimeout(function () { go(added ? checkout : url); }, 8000);
    fetch(root + 'cart.js', { headers: H, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}, n = 0;
        (cart.items || []).forEach(function (it) {
          if (ids.indexOf(it.variant_id) > -1 || drop.indexOf(it.handle) > -1) { updates[it.key] = 0; n++; }
        });
        return n ? fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ updates: updates }) }) : null;
      })
      .then(function () {
        if (done) return null;
        var item = { id: c.id, quantity: 1 };
        if (c.plan) item.selling_plan = c.plan;
        added = true;
        return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ items: [item] }) });
      })
      .then(function (r) {
        if (!r) return;
        if (r.ok) { go(checkout); return; }
        added = false; // refused (sold out, plan gone…): the plain link lets Shopify's own page say why
        go(url);
      })
      .catch(function () { go(added ? checkout : url); });
  }
  function upGo(url, link, mgUrl) {
    if (upBusy || !url) return;
    upBusy = true;
    if (link) link.classList.add('is-going');
    var dlg = upDialog(), yes = dlg && dlg.querySelector('[data-mfb-up-yes]');
    var ids = [url, mgUrl, yes && yes.getAttribute('href')].map(function (u) { var c = parseClaim(u); return c ? c.id : 0; })
      .filter(function (v, i, all) { return v && all.indexOf(v) === i; });
    var drop = ((dlg && dlg.getAttribute('data-mfb-drop')) || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    claimTo(url, ids, drop);
  }
  // .is-more while part of the card is still below the sticky buttons (a fade above them says so).
  function upMore(d) { d.classList.toggle('is-more', d.scrollHeight - d.scrollTop - d.clientHeight > 2); }
  function upOpen(d) {
    d.showModal();
    document.documentElement.classList.add('mfb-lock');
    upMore(d);
  }
  function upsell() {
    // pointerdown + click both on the backdrop = close; a text selection dragged out of the card does not count.
    document.addEventListener('pointerdown', function (e) { var d = upDialog(); upDown = !!d && e.target === d; }, true);
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var dlg = upDialog(), t = e.target;
      if (!dlg || !t || !t.closest) return;
      var pick = t.closest('[data-mfb-up-yes], [data-mfb-up-no]');
      if (pick && dlg.contains(pick)) {
        e.preventDefault();
        var no = pick.hasAttribute('data-mfb-up-no');
        if (no) upChoice('no');
        upGo(pick.getAttribute('href'), pick, dlg.querySelector('[data-mfb-up-no]').getAttribute('href'));
        return;
      }
      if (t === dlg) { if (upDown) dlg.close(); return; }
      if (t.closest('[data-mfb-up-close]')) { dlg.close(); return; }
      var a = t.closest('a[data-mfb-claim]');
      if (!a || a.hasAttribute('data-mfb-unwired')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      e.preventDefault();
      if (upChoice() === 'no') { upGo(href, a, href); return; }
      dlg.querySelector('[data-mfb-up-no]').setAttribute('href', href);
      upOpen(dlg);
    });
    // 'scroll' and 'close' do not bubble; capturing listeners still see them.
    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('dialog[data-mfb-upsell]')) upMore(e.target);
    }, true);
    window.addEventListener('resize', function () { var d = upDialog(); if (d && d.open) upMore(d); });
    // Esc, the X and the backdrop all end in 'close'.
    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches('dialog[data-mfb-upsell]')) document.documentElement.classList.remove('mfb-lock');
    }, true);
    // Back from checkout (page restored from the back/forward cache): buttons work again.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      upBusy = false;
      document.querySelectorAll('.mfb .is-going').forEach(function (n) { n.classList.remove('is-going'); });
    });
    // Theme editor: selecting the section opens the popup so it can be edited; deselecting closes it.
    document.addEventListener('shopify:section:select', function (e) {
      var d = upDialog();
      if (d && e.target.contains(d) && !d.open) upOpen(d);
    });
    document.addEventListener('shopify:section:deselect', function (e) { var d = upDialog(); if (d && e.target.contains(d) && d.open) d.close(); });
    document.addEventListener('shopify:section:load', monthDates);
  }

  function init() {
    var c = config();
    countdowns(c.deadline, c.farHours);
    refillDates(c.refillDays, c.refillMonths);
    monthDates();
    wire(c.checkout, c.code);
    observe();
    upsell();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
